<template>
  <v-container fill-height fluid>
    <v-row v-if="recommendedBooks.length != 0">
      <v-col align="center" justify="center">
        <h1>回饋問卷</h1>
      </v-col>
    </v-row>

    <v-card v-if="recommendedBooks.length == 0" class="mx-auto my-6" max-width="374" elevation="2" outlined>
      <v-card-title>
        目前尚無可供評價的書籍
      </v-card-title>
    </v-card>

    <v-card v-else class="mx-auto my-6" max-width="374" elevation="2" outlined>
      <v-card-subtitle>
        <p> 請點選書籍給予回饋意見 </p>
      </v-card-subtitle>
      <v-row v-for="(book, idx) in recommendedBooks" :key="book.id" dense>
        <book-card
            @click="showReviewDialog(book.book_number, idx)"
            :title="book.title"
            :desc="book.descShort"
            :imageUrl="'/img/books/' + book.id + '_bc.jpeg'"
        ></book-card>
      </v-row>

      <v-card-text>
        <p> 請選擇您的小朋友感興趣的主題(多選，可左右滑動)</p>
        <v-row justify="space-around">
          <v-col
              cols="12"
              sm="10"
              md="8"
          >
            <v-chip-group
                multiple
                active-class="primary"
                v-model="reviewSelectedTopics"
            >
              <v-chip
                  v-for="topic in nextTopics"
                  :key="topic"
              >
                {{ topic }}
              </v-chip>
            </v-chip-group>

          </v-col>
        </v-row>
      </v-card-text>


      <v-card-text>
        <v-row justify="space-around">
          <v-textarea
              filled
              label="您的回饋意見"
              auto-grow
              v-model="reviewText"
          ></v-textarea>
        </v-row>
      </v-card-text>
    </v-card>
    <br/><br/><br/>
    <br/><br/><br/>
    <v-dialog
        v-model="showDialog"
        max-width="290"
    >
      <v-card v-if="showDialog">

        <v-card-title class="headline">
          {{ this.recommendedBooks[this.currentBookId].title }}
        </v-card-title>

        <v-card-text>
            <v-rating
                v-model="rating"
                background-color="green lighten-3"
                color="green"
            ></v-rating>

          <v-row justify="space-around">
            <v-col
                cols="12"
                sm="10"
                md="8"
            >
                <v-chip-group

                    active-class="primary"
                >
                  <v-chip
                      v-for="item in tags"
                      :key="item.key"
                      @click="level=item.key"
                  >
                    {{ item.val }}
                  </v-chip>
                </v-chip-group>

            </v-col>
          </v-row>

        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
              color="green darken-1"
              text
              @click="changeBookRating('confirm')"
          >
            確認
          </v-btn>

          <v-btn
              color="green darken-1"
              text
              @click="changeBookRating('cancel')"
          >
            返回
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-row v-if="recommendedBooks.length == 0">
      <v-col align="center" justify="center" class="fixed-button">
        <v-btn rounded  dark x-large @click="goBack()">
          回上頁
        </v-btn>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col align="center" justify="center" class="fixed-button">
        <v-btn rounded color="success" dark x-large @click="sendReviewData()">
          送出
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// @ is an alias to /src
import bookJSON from "@/data/book.json";
import BookCard from "@/components/BookCard.vue";

let api_url = process.env.VUE_APP_API_URL;

export default {
  name: "ReviewDetails",
  components: {BookCard},
  data() {
    return {
      books: bookJSON,
      recommendedBooks: [],
      showDialog: false,
      currentBookNumber: null,
      currentBookId: null,
      callbackUrlObj: null,
      // tags: ['1', '2', '3'],
      tags: [
          {"key": 3, "val": "太深"},
          {"key": 2, "val": "適中"},
          {"key": 1, "val": "太淺"}
          ],
      nextTopics: [
          "負責", "勇敢", "堅強", "感恩", "樂觀", "自信", "獨立", "善良", "寬容", "誠信"
      ],
      rating: null,
      level: null,
      reviewBooksData: [],
      reviewSelectedTopics: [],
      reviewText: null,
      reviewData: null,
    };
  },
  mounted() {
    console.log(this.books);
    // this.pickBooksRandom(4);
    this.getHistoryBooks();
  },
  methods: {
    showReviewDialog(book_number, idx){
      this.showDialog = true;
      this.currentBookNumber = book_number;
      this.currentBookId = idx;
      if (this.reviewBooksData[this.currentBookId] != undefined) {
        this.rating = this.reviewBooksData[this.currentBookId].rating;
        this.level = this.reviewBooksData[this.currentBookId].level;
      }
    },
    changeBookRating(action) {
      if (action == 'confirm') {
        this.reviewBooksData[this.currentBookId] = {
          "id": this.recommendedBooks[this.currentBookId].book_id,
          "rating": this.rating,
          "level": this.level
        }
      }
      this.rating = null;
      this.level = null;
      this.showDialog = false;
    },
    getHistoryBooks() {
      var data = JSON.stringify(false);
      var xhr = new XMLHttpRequest();
      this.recommendedBooks = [];
      xhr.addEventListener("readystatechange", () => {
        if (xhr.readyState === 4) {
          console.log(xhr.responseText);
          let result = JSON.parse(xhr.responseText);
          if (xhr.status == 200) {
            console.log(result);
            result.forEach((historyBook) => {
              let book = historyBook.book;
              let bookData = {
                id: book.book_number,
                title: book.title,
                descShort: (book.summary) ? book.summary.substring(0, 30) + " >> 填寫" : "No data",
                desc: book.summary,
                "book_id": book.id
              };
              this.recommendedBooks.push(bookData);
              this.reviewBooksData.push({"id": book.id, "rating": null, "level": 0})
            });
          } else {
            alert(result.error.message);
          }
        }
      });

      xhr.open(
          "GET",
          api_url +
          "/api/family/" +
          this.$store.state.userId +
          "/members/" +
          this.$route.params.memberId +
          "/history/?status=3"
      );

      xhr.setRequestHeader("Content-Type", "application/json");

      xhr.send(data);
    },
    prepareReviewData() {
      this.reviewData = {
        "books": this.reviewBooksData,
        "review": this.reviewText,
        "next_topic": []
      }
      this.reviewSelectedTopics.forEach((topicIdx) => {
        this.reviewData['next_topic'].push(this.nextTopics[topicIdx])
      })

    },
    sendReviewData() {
      if (this.reviewSelectedTopics.length === 0) {
        alert("請選擇感興趣的主題")
        return
      }
      this.prepareReviewData();


      var data = JSON.stringify(this.reviewData);

      var xhr = new XMLHttpRequest();

      xhr.addEventListener("readystatechange", () => {
        if (xhr.readyState === 4) {
          console.log(xhr.responseText);
          let result = JSON.parse(xhr.responseText);
          if (xhr.status == 200) {
            alert("填寫完畢，謝謝您的回饋意見")

            if (this.isMobile()) {
              liff.closeWindow();
            } else {
              window.close();
            }

          } else {
            alert(result.error.message);
          }
        }
      });

      xhr.open(
          "POST",
          api_url +
          "/api/books/" +
          this.$store.state.userId +
          "/" +
          this.$route.params.memberId +
          "/review/"
      );
      xhr.setRequestHeader("Content-Type", "application/json");

      xhr.send(data);

    },
    goBack(){
      this.$router.push('/review')
    },
    isMobile() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    }
  },
};
</script>

<style>
</style>